import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { SELECT_QUESTIONNAIRE_STATE } from '../store/questionnaire.selectors';
import { PartialUrl } from 'src/app/core/enums/partial-url.enum';

/**
 * Has questions Guard
 */

/**
 * Replaces union type with type alias
 */
type booleanUrlTree = boolean | UrlTree;
@Injectable()
export class HasQuestionsGuard {
	/**
	 * Has questions constructor
	 *
	 * @param _store store
	 * @param _router router
	 */
	constructor(
		private _store: Store,
		private _router: Router,
	) {}

	/**
	 * Checks if the user can activate an element or event
	 *
	 * @returns true if the home store has questions
	 */
	canActivate(): Observable<booleanUrlTree> | booleanUrlTree {
		return this._hasQuestions();
	}

	/**
	 * Checks if the user can load an element or event
	 *
	 * @param route Route
	 * @param segments URL segments
	 * @returns true if the home store has questions
	 */
	canLoad(): Observable<booleanUrlTree> | booleanUrlTree {
		return this._hasQuestions();
	}

	/**
	 * Checks if the home store has questions
	 *
	 * @returns true if the home store has questions
	 */
	private _hasQuestions(): Observable<booleanUrlTree> | booleanUrlTree {
		return this._store.select(<any>SELECT_QUESTIONNAIRE_STATE).pipe(
			map((state: any) => {
				if (state.questions.length > 0) {
					return true;
				} else {
					return this._router.parseUrl(PartialUrl.HOME);
				}
			}),
		);
	}
}
